// Theme: polar-aurora
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'polar-aurora',
  name: 'POLAR AURORA',
  tagline: 'POLAR AURORA',
  description: 'Aurora boreal em variacao verde-roxa com atmosfera polar.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#071226', '#18264A', '#A58BFF', '#EAF2FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 28%, transparent)'
    },
    shellClasses: 'font-sans theme-polar-aurora'
  },
  colorVars: {
    '--accent': '#7AF5C2',
    '--accent-foreground': '#071226',
    '--background': '#071226',
    '--border': '#44508E',
    '--card': '#18264A',
    '--card-border-active': 'rgba(165, 139, 255, 0.42)',
    '--card-completed': '#152140',
    '--card-foreground': '#EAF2FF',
    '--card-glow': 'rgba(165, 139, 255, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#071226',
    '--foreground': '#EAF2FF',
    '--hold-fill': '#A58BFF',
    '--input': '#44508E',
    '--modal-bg': '#071226',
    '--modal-border': '#44508E',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--muted': '#44508E',
    '--muted-foreground': '#C9D4FF',
    '--nav-active': '#A58BFF',
    '--nav-bg': '#18264A',
    '--popover': '#18264A',
    '--popover-foreground': '#EAF2FF',
    '--primary': '#A58BFF',
    '--primary-foreground': '#071226',
    '--ring': '#A58BFF',
    '--secondary': '#44508E',
    '--secondary-foreground': '#EAF2FF',
    '--streak': '#A58BFF',
    '--success': '#22c55e',
    '--success-foreground': '#071226',
    '--xp': '#A58BFF',
    '--xp-bg': '#18264A'
  },
  resolvedVars: {
    '--accent': '#7AF5C2',
    '--accent-foreground': '#071226',
    '--accent-foreground-hsl': '219 69% 9%',
    '--accent-foreground-oklch': 'from #071226 l c h',
    '--accent-hsl': '155 86% 72%',
    '--accent-oklch': 'from #7AF5C2 l c h',
    '--background': '#071226',
    '--background-hsl': '219 69% 9%',
    '--background-oklch': 'from #071226 l c h',
    '--border': '#44508E',
    '--border-hsl': '230 35% 41%',
    '--border-oklch': 'from #44508E l c h',
    '--border-w': '1px',
    '--card': '#18264A',
    '--card-border-active': 'rgba(165, 139, 255, 0.42)',
    '--card-completed': '#152140',
    '--card-completed-hsl': '223 51% 17%',
    '--card-completed-oklch': 'from #152140 l c h',
    '--card-foreground': '#EAF2FF',
    '--card-foreground-hsl': '217 100% 96%',
    '--card-foreground-oklch': 'from #EAF2FF l c h',
    '--card-glow': 'rgba(165, 139, 255, 0.10)',
    '--card-hsl': '223 51% 19%',
    '--card-oklch': 'from #18264A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#071226',
    '--destructive-foreground-hsl': '219 69% 9%',
    '--destructive-foreground-oklch': 'from #071226 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EAF2FF',
    '--foreground-hsl': '217 100% 96%',
    '--foreground-oklch': 'from #EAF2FF l c h',
    '--hold-fill': '#A58BFF',
    '--hold-fill-hsl': '253 100% 77%',
    '--hold-fill-oklch': 'from #A58BFF l c h',
    '--input': '#44508E',
    '--input-hsl': '230 35% 41%',
    '--input-oklch': 'from #44508E l c h',
    '--modal-bg': '#071226',
    '--modal-bg-hsl': '219 69% 9%',
    '--modal-bg-oklch': 'from #071226 l c h',
    '--modal-border': '#44508E',
    '--modal-border-hsl': '230 35% 41%',
    '--modal-border-oklch': 'from #44508E l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--muted': '#44508E',
    '--muted-foreground': '#C9D4FF',
    '--muted-foreground-hsl': '228 100% 89%',
    '--muted-foreground-oklch': 'from #C9D4FF l c h',
    '--muted-hsl': '230 35% 41%',
    '--muted-oklch': 'from #44508E l c h',
    '--nav-active': '#A58BFF',
    '--nav-active-hsl': '253 100% 77%',
    '--nav-active-oklch': 'from #A58BFF l c h',
    '--nav-bg': '#18264A',
    '--nav-bg-hsl': '223 51% 19%',
    '--nav-bg-oklch': 'from #18264A l c h',
    '--popover': '#18264A',
    '--popover-foreground': '#EAF2FF',
    '--popover-foreground-hsl': '217 100% 96%',
    '--popover-foreground-oklch': 'from #EAF2FF l c h',
    '--popover-hsl': '223 51% 19%',
    '--popover-oklch': 'from #18264A l c h',
    '--primary': '#A58BFF',
    '--primary-foreground': '#071226',
    '--primary-foreground-hsl': '219 69% 9%',
    '--primary-foreground-oklch': 'from #071226 l c h',
    '--primary-hsl': '253 100% 77%',
    '--primary-oklch': 'from #A58BFF l c h',
    '--radius': '12px',
    '--ring': '#A58BFF',
    '--ring-hsl': '253 100% 77%',
    '--ring-oklch': 'from #A58BFF l c h',
    '--secondary': '#44508E',
    '--secondary-foreground': '#EAF2FF',
    '--secondary-foreground-hsl': '217 100% 96%',
    '--secondary-foreground-oklch': 'from #EAF2FF l c h',
    '--secondary-hsl': '230 35% 41%',
    '--secondary-oklch': 'from #44508E l c h',
    '--shadow-card': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 28%, transparent)',
    '--streak': '#A58BFF',
    '--streak-hsl': '253 100% 77%',
    '--streak-oklch': 'from #A58BFF l c h',
    '--success': '#22c55e',
    '--success-foreground': '#071226',
    '--success-foreground-hsl': '219 69% 9%',
    '--success-foreground-oklch': 'from #071226 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(253 100% 77% / 0.15)',
    '--xp': '#A58BFF',
    '--xp-bg': '#18264A',
    '--xp-bg-hsl': '223 51% 19%',
    '--xp-bg-oklch': 'from #18264A l c h',
    '--xp-hsl': '253 100% 77%',
    '--xp-oklch': 'from #A58BFF l c h'
  }
}
